import { queryOptions } from "@tanstack/react-query";

import { authClient } from "@platform/auth/client";
import { api } from "@platform/core/api";
import type { Invitation, Member } from "./tenant.types";

export const membersQueryOptions = queryOptions({
	queryKey: ["tenant", "members"],
	queryFn: () => api.get<Member[]>("/platform/members"),
});

// A plain member lacks the permission to list invitations, so a failure resolves to an empty list.
export const invitationsQueryOptions = queryOptions({
	queryKey: ["tenant", "invitations"],
	queryFn: async (): Promise<Invitation[]> => {
		try {
			const { data } = await authClient.organization.listInvitations();
			const now = Date.now();
			return (data ?? [])
				.filter((i) => i.status === "pending" && new Date(i.expiresAt).getTime() > now)
				.map((i) => ({
					id: i.id,
					email: i.email,
					role: i.role as Member["role"],
					status: i.status,
				}));
		} catch {
			return [];
		}
	},
});
